<template>
  <div class="Vehicles__View">
    <EntityListLayout
      ref="entity"
      :tabs="tabs"
      @onNewEntitySave="onNewEntitySave"
    >
      <template #title>רכבים</template>
      <template #button v-if="isAdmin">
        <b-button @click="showNewEntity">הוספת רכב חדש</b-button>
      </template>
      <template v-slot:counter="slotProps">
        סה"כ <b>{{ getTotalRecords(slotProps) }} </b>
      </template>
    </EntityListLayout>
  </div>
</template>
<script>
import VehicleService from "@/services/VehicleService";
import EntityListLayout from "@/components/EntityListLayout.vue";
import VehicleEntity from "@/views/VehicleEntity.vue";
import FieldService from "@/services/FieldService";
import FilterService from "@/services/FilterService";
import NewVehicleEntity from "@/components/Entities/NewVehicleEntity.vue";
import TableActions from "@/services/TableActionsService";

import { saveAs } from "file-saver";

export default {
  name: "Reports",
  data() {
    return {
      tabs: [],
    };
  },
  components: {
    EntityListLayout,
  },
  computed: {
    tabName() {
      return this.selectedTab && this.selectedTab.title;
    },
    isAdmin() {
      return this.$store.state.auth?.user?.claims?.isAdmin === "True";
    },
  },
  created() {
    const vehicleFields = FieldService.list("vehicles");
    const vehiclefilters = FilterService.list();
    const { DateSearchTypes } = FilterService;

    const sideViewEntity = {
      component: VehicleEntity,
      preview: true,
      readOnly: true,
      title: "פרטי רכב",
      recordUrl: "vehicles",
    };
    this.tabs = [
      {
        id: "AllVehicles",
        title: "רכבים מנוהלים",
        newEntityComponent: NewVehicleEntity,
        getDataAsync: this.getAllVehicles,
        perPage: 20,
        fields: [
          { ...vehicleFields.VehiclePlateNumber, checked: true },
          { ...vehicleFields.VehicleType, checked: true, Sortable: true },
          { ...vehicleFields.Manufacturer, checked: true },
          { ...vehicleFields.Model, checked: true },
          { ...vehicleFields.Year, checked: true },
          { ...vehicleFields.Color, checked: true },
          { ...vehicleFields.IsManaged, checked: true, Sortable: true },
          { ...vehicleFields.Owner, checked: true, Sortable: true },
          { ...vehicleFields.Profile, checked: true, Sortable: true },
          { ...vehicleFields.StartContractDate, checked: true },
          { ...vehicleFields.EndContractDate, checked: true },
          { ...vehicleFields.ProfitCenter, checked: true },
        ],
        filters: [
          {
            ...vehiclefilters.Profile,
            Type: "FilterMultiDropdown",
            Query: "ProfileIds",
            selected: this.$route.query.ProfileIds,
          },
          { ...vehiclefilters.PlateNumber },
          { ...vehiclefilters.VehicleType },
          { ...vehiclefilters.VehicleOnlyOwnedByMe, isHidden: this.admin },
          {
            ...vehiclefilters.DateTypes,
            Options: [{ ...DateSearchTypes.VehicleCustomerContract }],
          },
        ],
        fastSearch: true,
        sortField: "DateTaken",
        sortOrder: "desc",
        excelExport: [
          {
            title: "יצוא טבלה",
            action: this.export,
          },
        ],
        sideViewEntity,
        checkableRows: this.isAdmin,
        tableActions: !this.isAdmin
          ? false
          : (() => [TableActions.updateExcludedVehicles])(),
      },
      /* {
        id: "NotManagedVehicles",
        title: "רכבים לא מנוהלים",
        getDataAsync: this.getUnmanaged,
        perPage: 20,
        excelExport: [
          {
            title: "יצוא טבלה",
            action: this.exportUnmanaged,
          },
        ],
        fields: [
          { ...vehicleFields.VehiclePlateNumber, checked: true, disableLinks: true, Sortable: false },
          { ...vehicleFields.Reason, checked: true, Sortable: false }
        ],
        sortField: "DateTaken",
        sortOrder: "desc",

        checkableRows: this.isAdmin,
        tableActions: !this.isAdmin
          ? false
          : (() => [TableActions.updateExcludedVehicles])(),
      }, */
    ];
    if (this.isAdmin) {
      this.tabs.push({
        id: "ExcludedVehicles",
        title: "רכבים שנגרעו",
        getDataAsync: this.getExcludedVehicles,
        perPage: 20,
        excelExport: [
          {
            title: "יצוא טבלה",
            action: this.exportUnmanaged,
          },
        ],
        fields: [{ ...vehicleFields.Enumerate, checked: true }],
        sortField: "DateTaken",
        sortOrder: "desc",
        checkableRows: this.isAdmin,
        tableActions: !this.isAdmin
          ? false
          : (() => [TableActions.removeExcludedVehicles])(),

        // checkableRows: this.isAdmin,
        // tableActions: !t Actions.updateExcludedVehicles])(),
      });
    }
  },
  methods: {
    showNewEntity() {
      this.$refs.entity.newEntityMenu();
    },
    onNewEntitySave() {
      this.$refs.entity.onNewEntityCancel();
    },
    exportUnmanaged({ loading }) {
      loading(true);
      VehicleService.unmanagedXls()
        .then((r) => {
          // Check headers in multiple ways (axios normalizes to lowercase)
          const contentType = r.headers && (r.headers["content-type"] || r.headers["Content-Type"]);
          let extention = "xlsx";
          let mimetype = this.excelMimeType;
          if (contentType && contentType.toLowerCase().includes("text/csv")) {
            extention = "csv";
            mimetype = "text/csv";
          }
          this.saveFile(r.data, "יצוא רכבים לא מנוהלים ממערכת Betterway", extention, mimetype);
        })
        .catch(() => {})
        .finally(() => {
          loading(false);
        });
    },
    export({ loading, query }) {
      loading(true);
      VehicleService.exportXls(query)
        .then((r) => {
          // Check headers in multiple ways (axios normalizes to lowercase)
          const contentType = r.headers && (r.headers["content-type"] || r.headers["Content-Type"]);
          let extention = "xlsx";
          let mimetype = this.excelMimeType;
          if (contentType && contentType.toLowerCase().includes("text/csv")) {
            extention = "csv";
            mimetype = "text/csv";
          }
          this.saveFile(r.data, "יצוא רכבים מנוהלים ממערכת Betterway", extention, mimetype);
        })
        .catch(() => {})
        .finally(() => {
          loading(false);
        });
    },
    getAllVehicles({ cancelToken, ...rest }) {
      return VehicleService.search(
        {
          ...rest,
        },
        cancelToken.token
      );
    },
    getUnmanaged({ cancelToken }) {
      return VehicleService.unmanaged(cancelToken.token).then((r) => ({
        data: {
          TotalResults: r.data.length,
          Items: r.data,
        },
      }));
    },
    getExcludedVehicles({ cancelToken }) {
      return VehicleService.getExcludedVehicles(cancelToken.token).then(
        (r) => ({
          data: {
            TotalResults: r.data.length,
            Items: r.data.PlateNumbers,
          },
        })
      );
    },
    getTotalRecords(slotProps) {
      return slotProps.tab && slotProps.tab.total && slotProps.tab.total;
    },
    saveFile(data, filename, extention = "xlsx", mimetype = null) {
      const blobType = mimetype || this.excelMimeType;
      const blob = new Blob([data], { type: blobType });
      saveAs(blob, `${filename}.${extention}`);
    },
  },
};
</script>
